import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { actionCreators } from "./action";
import { actionCreators as actionCreatorsCreateTask } from "../CreateTask/action";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import { CATEGORY } from "../TasksList/constants";
import { withRouter } from "react-router";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(0),
    minWidth: 120
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  }
}));

const useStylesMobile = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(0),
    minWidth: 120,
    fullWidth: true,
    display: "flex",
    wrap: "nowrap"
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  }
}));

const NewTaskForm = props => {
  const [state, setState] = useState({
    title: props.title ? props.title : "",
    tag: props.tag ? props.tag : "",
    description: props.description ? props.description : "",
    id: props.id ? props.id : "",
    action: props.action ? props.action : "",
    parent: props.parent ? props.parent : ""
  });

  const classes = useStyles();
  const classesMobile = useStylesMobile();

  const inputLabel = React.useRef(0);
  const [labelWidth, setLabelWidth] = React.useState(0);

  // alert(props.location.pathname);

  const isNext = props.location.pathname === "/next" && CATEGORY.NEXT;
  const isWating = props.location.pathname === "/wating" && CATEGORY.WAITING;
  const isScheduled =
    props.location.pathname === "/scheduled" && CATEGORY.SCHEDULED;
  const isSomeday = props.location.pathname === "/someday" && CATEGORY.SOMEDAY;

  const categoryPath = isNext || isWating || isScheduled || isSomeday || "";
  const parentPath = props.location.pathname.split("/")[2];

  useEffect(() => {
    setLabelWidth(inputLabel.current ? inputLabel.current.offsetWidth : 0);

    setState({
      title: props.title ? props.title : "",
      tag: props.tag ? props.tag : "",
      description: props.description ? props.description : "",
      id: props.id ? props.id : "",
      action: props.action ? props.action : categoryPath,
      parent: props.parent ? props.parent : parentPath ? parentPath : ""
    });
  }, [props]);

  function saveNewTask() {
    props.createTask(state);
  }

  function createNewProject() {
    props.createProject(state);
  }

  function saveTask() {
    props.saveTask(state);
  }

  const [width, setWidth] = React.useState(window.innerWidth);

  const handleWindowSizeChange = () => {
    setWidth({ width: window.innerWidth });
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
  });

  useEffect(() => {
    window.removeEventListener("resize", handleWindowSizeChange);

  }, []);

  const isStandalone = window.matchMedia("(display-mode: standalone)").matches;

  const isMobile = isStandalone || width <= 1328 || width.width <= 1328;
  const quickAdd = props.isFastAdd;

  return (
    props.isVisible ? (
      <Grid container spacing={3}>
        <Grid item xs={12} md={12} lg={12}>
          <Paper className={props.fixedHeightPaperMore}>
            <form noValidate autoComplete="off">
              <b>
                {" "}
                {props.isFormIsOpen && "New task"}
                {props.isEditFormIsOpen && "Edit task"}
              </b>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={8}>
                  <TextField
                    id="outlined-basic"
                    label="To Do "
                    variant="outlined"
                    fullWidth
                    value={state.title}
                    onChange={e => {
                      setState({ ...state, title: e.target.value });
                    }}
                  />
                </Grid>
                {!quickAdd && <Grid item xs={12} sm={3}>
                  <FormControl
                    variant="outlined"
                    className={
                      isMobile ? classesMobile.formControl : classes.formControl
                    }
                  >
                    <InputLabel
                      ref={inputLabel}
                      id="demo-simple-select-outlined-label"
                    >
                      Action
                  </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={state.action}
                      autoWidth={isMobile}
                      onChange={e => {
                        setState({ ...state, action: e.target.value });
                      }}
                      labelWidth={labelWidth}
                    >
                      <MenuItem value={CATEGORY.NEXT}>Next</MenuItem>
                      <MenuItem value={CATEGORY.WAITING}>Wating</MenuItem>
                      <MenuItem value={CATEGORY.SCHEDULED}>Scheduled</MenuItem>
                      <MenuItem value={CATEGORY.SOMEDAY}>Someday</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>}

                {!quickAdd && <Grid item xs={12} sm={8}>
                  <TextField
                    id="outlined-basic"
                    label="Tags"
                    variant="outlined"
                    fullWidth
                    value={state.tag}
                    onChange={e => {
                      setState({ ...state, tag: e.target.value });
                    }}
                  />
                </Grid>
                }

                {!quickAdd && <Grid item xs={12} sm={3}>
                  <FormControl
                    variant="outlined"
                    className={
                      isMobile ? classesMobile.formControl : classes.formControl
                    }
                  >
                    <InputLabel
                      ref={inputLabel}
                      id="demo-simple-select-outlined-label"
                    >
                      Project
                  </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={state.parent}
                      autoWidth={isMobile}
                      onChange={e => {
                        setState({ ...state, parent: e.target.value });
                      }}
                      labelWidth={labelWidth}
                    >
                      {props.projects &&
                        props.projects.map(project => (
                          <MenuItem value={project.id} key={project.id}>
                            {project.title}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
                }
                <Grid item xs={12} sm={8}>
                  <TextField
                    id="outlined-multiline-static"
                    label="Notes"
                    multiline
                    rows="2"
                    defaultValue="Default Value"
                    variant="outlined"
                    fullWidth
                    value={state.description}
                    onChange={e => {
                      setState({ ...state, description: e.target.value });
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={3}></Grid>

                {props.isEditFormIsOpen && (
                  <> <Grid item xs={12} sm={6}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={saveTask}
                      fullWidth={isMobile}
                    >
                      Save
                  </Button>{" "}
                  </Grid>
                    <Grid item xs={12} sm={6}>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={props.closeTaskForm}
                        fullWidth={isMobile}
                      >
                        Cancel
                  </Button>{" "}
                    </Grid>
                  </>
                )}

                {!isMobile && props.isFormIsOpen && (
                  <Grid item xs={12} sm={3}>
                    {" "}
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth={isMobile}
                      onClick={saveNewTask}
                    >
                      Create task
                  </Button>{" "}
                  </Grid>
                )}

                {!isMobile && props.isFormIsOpen && (
                  <Grid item xs={12} sm={3}>
                    {" "}
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={createNewProject}
                      fullWidth={isMobile}
                    >
                      Create Project
                  </Button>{" "}
                  </Grid>
                )}
                {!isMobile && props.isFormIsOpen && (
                  <Grid item xs={12} sm={3}>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={props.closeTaskForm}
                      fullWidth={isMobile}
                    >
                      Cancel
                  </Button>
                  </Grid>
                )}

                {!props.isEditFormIsOpen && isMobile && (
                  <>
                    <Grid item xs={12} sm={3}>
                      {" "}
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth={isMobile}
                        onClick={saveNewTask}
                      >
                        Create task
                    </Button>{" "}
                    </Grid>

                    <Grid item xs={12} sm={3}>
                      {" "}
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={createNewProject}
                        fullWidth={isMobile}
                      >
                        Create Project
                    </Button>{" "}
                    </Grid>

                    {!quickAdd && <Grid item xs={12} sm={3}>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={props.closeTaskForm}
                        fullWidth={isMobile}
                      >
                        Cancel
                    </Button>
                    </Grid>
                  }
                  </>
                )}

                <Grid item xs={12} sm={6}></Grid>
              </Grid>
            </form>
          </Paper>
        </Grid>
      </Grid>
    ) : null);
};

const mapStateToProps = state => {
  function isProjectNotDone(idTask) {
    const task = state.tasks[idTask];
    return task.project === true && task.done === false;
  }

  const projects =
    state.tasks &&
    Object.keys(state.tasks)
      .filter(isProjectNotDone)
      .map(key => state.tasks[key]);

  return {
    isEditFormIsOpen: state.isFormIsOpen.isEditFormIsOpen,
    isFormIsOpen: state.isFormIsOpen.isFormIsOpen,
    projects: projects
  };
};

const enhance = compose(
  withRouter,
  connect(mapStateToProps, {
    ...actionCreators,
    ...actionCreatorsCreateTask
  })
)(NewTaskForm);

export default enhance;
